//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            details: [
                this.$t('technical_features.content.1'),
                this.$t('technical_features.content.2'),
                this.$t('technical_features.content.3'),
            ],
        };
    },
    head() {
        return {
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('title'),
                },
            ],
            title: this.$t('title'),
        };
    },
};
